import { render, staticRenderFns } from "./PopupMenu.vue?vue&type=template&id=05563442"
import script from "./PopupMenu.vue?vue&type=script&lang=js"
export * from "./PopupMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports